var NotificationService = /** @class */ (function () {
    function NotificationService() {
    }
    NotificationService.subscribe = function (subscriber) {
        NotificationService.subscriber = subscriber;
    };
    NotificationService.notify = function (message) {
        if (NotificationService.subscriber == null) {
            return;
        }
        NotificationService.subscriber.notify(message);
    };
    NotificationService.subscriber = null;
    return NotificationService;
}());
export { NotificationService };
